import { createConfig, http } from "wagmi";
import { defineChain } from "viem";
import { injected } from "wagmi/connectors";
import { chainbridgeConfig } from "./chainbridgeConfig";

// Build viem chain definitions from the environment-specific bridge config.
// rpcUrl may be ws/wss (used by ethers listeners) or http — we always expose
// an http transport here; ethers handles websocket subscriptions separately.
const viemChains = chainbridgeConfig.chains.map((c) =>
  defineChain({
    id: c.networkId,
    name: c.name,
    nativeCurrency: {
      name: c.nativeTokenSymbol,
      symbol: c.nativeTokenSymbol,
      decimals: 18,
    },
    rpcUrls: {
      default: {
        http: [c.rpcUrl.startsWith("ws") ? "" : c.rpcUrl],
      },
    },
    ...(c.blockExplorer && {
      blockExplorers: {
        default: { name: "Explorer", url: c.blockExplorer },
      },
    }),
  })
);

// wagmi requires a non-empty tuple — safe since chainbridgeConfig always has ≥2 chains
const [firstChain, ...restChains] = viemChains as [
  ReturnType<typeof defineChain>,
  ...ReturnType<typeof defineChain>[]
];

export const wagmiConfig = createConfig({
  chains: [firstChain, ...restChains],
  transports: Object.fromEntries(
    viemChains.map((c) => [c.id, http(c.rpcUrls.default.http[0] || undefined)])
  ),
  connectors: [
    // Handles MetaMask, AlphaWallet, and any other EIP-1193 injected wallet.
    // Add walletConnect({ projectId }) here when a WalletConnect project ID is available.
    injected(),
  ],
});
